"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _adminQueryKey = _interopRequireDefault(require("./adminQueryKey"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  all: _adminQueryKey["default"]
};
exports["default"] = _default;